import { render, staticRenderFns } from "./Scheme.vue?vue&type=template&id=2394f2bc&"
import script from "./Scheme.vue?vue&type=script&lang=ts&"
export * from "./Scheme.vue?vue&type=script&lang=ts&"
import style0 from "./Scheme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports